export const clearCardList = () => ({
  type: 'CLEAR_CARD_LIST',
});

export const setUserCardList = (cardList) => {
  console.log('Dispatching SET_CARD_LIST with:', cardList);
  return {
    type: 'SET_CARD_LIST',
    payload: cardList,
  };
};
